<script setup lang="ts">
import type { AppCircleCheckboxTheme } from './AppCircleCheckbox.model';
import CheckedIcon from './CheckedIcon.vue';
import UncheckedIcon from './UncheckedIcon.vue';

interface AppCircleCheckboxProps {
  checked: boolean;
  theme: AppCircleCheckboxTheme;
}

const props = defineProps<AppCircleCheckboxProps>();

interface AppCircleCheckboxEmits {
  (eventName: 'click'): void;
}

const emit = defineEmits<AppCircleCheckboxEmits>();
</script>

<template>
  <div class="app-circle-checkbox" @click="emit('click')">
    <CheckedIcon
      v-if="props.checked"
      :checked="props.checked"
      :theme="props.theme"
    />
    <UncheckedIcon v-else :theme="props.theme" />
  </div>
</template>
